<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-3">
          <!-- mini card section -->
          <div class="row">
            <div class="col-lg mt-4">
              <card
                type="small"
                :title="connectionstatus"
                subtitle="Lux Connection Status"
                :img="connectionstatusIcon"
              >
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg mt-4">
              <card
                type="small"
                :title="luxlevel"
                subtitle="Lux Level"
                :img="luxlevelIcon"
              >
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg mt-4">
              <card
                style="padding: 15px 0"
                :title="batterylevel"
                subtitle="Battery Level"
                :img="batterylevelIcon"
                type="small"
              >
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg mt-4">
              <card
                type="small"
                style="padding: 15px 0"
                :title="transmissioninterval"
                subtitle="Transmission Interval"
                :img="transmissionintervalIcon"
              >
              </card>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <!-- map -->
          <div class="row">
            <div class="col-lg mt-4">
              <div id="map" class="map">
                <l-map
                  ref="luxMap"
                  :zoom="zoom"
                  :options="{ zoomControl: false }"
                  :center="center"
                  :bounds="devBounds"
                  :style="{
                    height: '289px',
                    boxShadow: '0px 3px 6px #bfc5db14',
                    zIndex: 1,
                    borderRadius: '8px',
                  }"
                  @ready="onMapReady"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>

                  <l-marker
                    v-for="(item, index) in markers"
                    :key="index"
                    :lat-lng="item.latLng"
                    :icon="markerIcon()"
                  >
                    <l-tooltip v-if="item.name !== ''">
                      <div>
                        {{ item.name }}
                      </div>
                    </l-tooltip>
                  </l-marker>
                  <!-- <l-control position="bottomright" class="custom-legend">
                    <div class="row">
                      <div class="col-lg-10">
                        <h3>Legend</h3>
                      </div>
                      <div class="col-lg-2 text-right">
                        <i
                          class="fa fa-chevron-down"
                          style="cursor: pointer"
                          aria-hidden="true"
                          v-if="collapse == false"
                          @click="collapse = true"
                        ></i>
                        <i
                          class="fa fa-chevron-up"
                          style="cursor: pointer"
                          aria-hidden="true"
                          v-if="collapse"
                          @click="collapse = false"
                        ></i>
                      </div>
                    </div>

                    <div
                      v-if="!collapse"
                      class="custom-legend-item d-flex align-items-center"
                      v-for="item in legends"
                      :key="item.label"
                    >
                      <input
                        type="checkbox"
                        class="styled-radio-checkbox me-2"
                        :id="`legend-${item.label}`"
                        v-model="item.checked"
                        @change="onLegendToggle(item)"
                      />

                      <img
                        :src="markerIcon(item.icon)"
                        class="custom-legend-icon"
                      />
                      <span class="mx-2" style="width: 150px">{{
                        item.label
                      }}</span
                      ><span>{{
                        item.value !== null ? `(${item.value})` : "N/A"
                      }}</span>
                    </div>
                  </l-control> -->
                </l-map>
              </div>
            </div>
          </div>
          <!-- chart -->
          <div class="row">
            <div class="col-lg mt-4">
              <card type="plain">
                <br />
                <div class="row">
                  <div class="col-lg text-center">
                    <p>Lux Level Graph</p>
                  </div>
                </div>
                <br />
                <br />

                <!-- <div class="row">
                  <div class="col-lg"></div>
                  <div class="col-lg-6 text-center">
                    <Datepicker
                      class="datepicker-here form-control digits"
                      id="dateRange"
                      v-model="dateRange"
                      :enable-time-picker="false"
                      :format="formatDateRange"
                      range
                      placeholder="Select date"
                    ></Datepicker>
                  </div>
                  <div class="col-lg"></div>
                </div> -->
                <Line
                  v-if="luxChart.loaded"
                  chartId="lux-chart"
                  :chartOptions="luxChart.options"
                  :chartData="luxChart.chartData"
                  :height="210"
                />
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mt-4">
          <!-- outer white card -->
          <div
            style="
              background-color: #ffffff;
              border-radius: 5px;
              padding: 20px;
              height: 100%;
            "
          >
            <div class="row">
              <div class="col-lg">
                <p
                  style="
                    font-family: Poppins;
                    font-weight: 600;
                    font-style: SemiBold;
                    font-size: 16px;
                    color: #000000;
                    line-height: 100%;
                    letter-spacing: 0%;
                    text-align: center;
                  "
                >
                  {{ currentlux }} lx
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p
                  style="
                    font-family: Poppins;
                    font-weight: 400;
                    font-style: Regular;
                    font-size: 16px;
                    color: #ababab;
                    line-height: 100%;
                    letter-spacing: 0%;
                    text-align: center;
                  "
                >
                  Current Lux Level Indicator
                </p>
              </div>
            </div>
            <div
              style="
                height: 85%;
                background-color: pink;
                border-radius: 5px;
                background: linear-gradient(
                  180deg,
                  #86ccf7 0%,
                  #728591 49.39%,
                  #1b597f 74.3%,
                  #0e2634 100%
                );
              "
            >
              <div class="row">
                <!-- left: 50px;
                position: relative;
                max-width: 200px; 
                min-width: 200px -->
                <div class="col-lg" style="margin-top: 15px">
                  <div class="row">
                    <div class="col-lg text-center">
                      <img src="@/assets/img/lux meter.png" />
                    </div>
                  </div>

                  <div :style="rigtharrow">
                    <i
                      style="
                        color: #ffd811;
                        font-size: 50px;
                        position: absolute;
                      "
                      class="fa fa-caret-right"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div :style="leftarrow">
                    <i
                      style="
                        color: #ffd811;
                        font-size: 50px;
                        position: absolute;
                      "
                      class="fa fa-caret-left"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <modal :show.sync="modals.date" type="medium">
        <template slot="header">
          <h3 class="modal-title">Choose date range</h3>
        </template>
        <div class="row">
          <div class="col-lg">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              start-placeholder="Start date"
              end-placeholder="End date"
            ></el-date-picker>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div class="row">
          <div class="col-lg text-center">
            <base-button class="btn-success btn-round" @click="saveDate()"
              >Save</base-button
            >
          </div>
        </div>
      </modal> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";

import "leaflet/dist/leaflet.css";
import { latLngBounds } from "leaflet";

import {
  LMap,
  LMarker,
  LTileLayer,
  LTooltip,
  LIcon,
  LControl,
} from "@vue-leaflet/vue-leaflet";

export default {
  components: {
    Datepicker,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LControl,
  },
  data() {
    return {
      dateRange: [],

      isLoading: false,
      isChartLoading: false,
      luxname: "-",
      lastupdate: "- Minutes Ago",

      connectionstatus: "Online",
      connectionstatusTitle: "Connection Status",
      connectionstatusIcon: require("@/assets/img/wifi.png"),

      luxlevel: "-",
      luxlevelTitle: "LUX Level",
      luxlevelIcon: require("@/assets/img/lux.png"),

      transmissioninterval: "- Min",
      transmissionintervalTitle: "Transmission Interval",
      transmissionintervalIcon: require("@/assets/img/clock.png"),

      batterylevel: "-%",
      batterylevelTitle: "Battery Level",
      batterylevelIcon: require("@/assets/img/battery.png"),

      noderssi: "-",
      gatewayrssi: "-",
      luxvalue: "-",

      //   top
      rigtharrow: "position: absolute;left: 15px; top: 5%;",
      leftarrow: "position: absolute;right: 35px; top: 5%;",

      // middle
      // rigtharrow: "position: absolute;left: 15px; top: 44%;",
      // leftarrow: "position: absolute;right: 35px; top: 44%;",

      // bottom
      // rigtharrow: "position: absolute;left: 15px; top: 83%;",
      // leftarrow: "position: absolute;right: 35px; top: 83%;",

      currentlux: 0,
      zoom: 18,
      center: [3.15464, 101.718635],
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ',
      markers: [
        {
          latLng: [3.15464, 101.718635],
          name: "lux",
        },
      ],
      devBounds: latLngBounds([2.928236, 101.48424], [2.9284, 101.68424]),

      filter: {
        date1: "-",
        date2: "-",
      },
      luxChart: {
        chartData: {
          // "A", "B", "C", "D", "E", "F", "G"
          labels: [],
          datasets: [
            {
              backgroundColor: "#218863",
              pointBorderColor: "#218863",
              borderColor: "#BCEFDB",
              fill: false,
              data: this.items?.Data,
              id: "current",
              label: "",
              yAxisID: "y",
              lineTension: 0.4,
            },
          ],
        },
        loaded: false,
        options: {
          legend: {
            display: false,
          },
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          stacked: false,
          plugins: {
            title: {
              display: false,
              text: "Chart.js Line Chart - Multi Axis",
            },
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              type: "linear",
              display: true,
              position: "left",
              title: { display: false, text: "°C" },
              min: 0,
            },
          },
        },
      },
      modals: {
        date: false,
      },

      deviceid: "",
      devicetoken: "",
      start: "",
      end: "",
      mapReady: false,
    };
  },
  created() {
    this.dateRange = [moment().subtract(24, "hours"), moment()];

    this.getLuxData();
    this.getLuxDetail();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDateRange(dateRange) {
      if (Array.isArray(dateRange)) {
        return dateRange.map(this.formatDate).join(" - ");
      }
      return "";
    },
    async fitMapToMarkers() {
      if (this.markers && this.markers.length && this.mapReady) {
        const bounds = L.latLngBounds(
          this.markers.map((marker) => marker.latLng)
        );
        if (!this.$refs.luxMap) return;
        const map = this.$refs.luxMap.leafletObject;
        if (map) {
          map.invalidateSize(); // Recalculate the map size
          map.fitBounds(bounds);
        } else {
          console.error("Map object not found");
        }
      }
    },
    onMapReady() {
      this.mapReady = true;
      this.fitMapToMarkers();
    },

    markerIcon() {
      return L.icon({
        iconSize: [30, 30],
        iconUrl: require("@/assets/img/lux.png"),
        popupAnchor: [-3, -76],
      });
    },
    getLuxDetail() {
      this.$http
        .get(":11000/api/v1/lux/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("RAW LUX GRAPH RESPONSE:", response);

            console.log(response);
            this.connectionstatus = response.LuxStatus;
            this.luxlevel = response.LuxLevel;
            this.batterylevel = response.BatteryLevel;
            this.transmissioninterval = "30 Minutes";

            this.markers = [
              {
                latLng: [response.Latitude, response.Longitude],
                name: "lux",
              },
            ];

            this.devBounds = latLngBounds([
              response.Latitude,
              response.Longitude,
            ]);

            this.currentlux = response.LuxValue;

            if (response.LuxLevel.toUpperCase() == "BRIGHT") {
              this.rigtharrow = "position: absolute;left: 15px; top: 5%;";
              this.leftarrow = "position: absolute;right: 35px; top: 5%;";
            }
            if (response.LuxLevel.toUpperCase() == "CLOUDY") {
              this.rigtharrow = "position: absolute;left: 15px; top: 44%;";
              this.leftarrow = "position: absolute;right: 35px; top: 44%;";
            }
            if (response.LuxLevel.toUpperCase() == "DARK") {
              this.rigtharrow = "position: absolute;left: 15px; top: 83%;";
              this.leftarrow = "position: absolute;right: 35px; top: 83%;";
            }
          }
        });
    },

    getLuxData() {
      this.luxChart.loaded = false;
      console.log(this.dateRange);
      let s = moment().startOf("d").format("YYYY-MM-DD");
      let e = moment().endOf("d").format("YYYY-MM-DD");

      // let s = "2025-06-30";
      // let e = "2025-08-01";

      this.$http
        .get(
          ":11000/api/v1/lux/graph/" +
            this.$route.query.id +
            "?startDate=" +
            s +
            "&endDate=" +
            e
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            if (response.length == 0) {
              console.log("woi");
              this.isLoading = false;
            }
            if (response.length != 0) {
              // assign chart data
              const formattedDates = response.Timestamp.map((date) =>
                moment(date).format("hh:mm a")
              );
              this.luxChart = {
                chartData: {
                  labels: formattedDates,
                  datasets: [
                    {
                      label: "Data",
                      backgroundColor: "#218863",
                      pointBorderColor: "#218863",
                      borderColor: "#BCEFDB",
                      fill: false,

                      id: "current",

                      yAxisID: "y",
                      lineTension: 0.4,

                      data: response.LuxValue,
                    },
                  ],
                },
                loaded: true,
                options: {
                  legend: {
                    display: false,
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                  interaction: {
                    mode: "index",
                    intersect: false,
                  },
                  stacked: false,
                  plugins: {
                    title: {
                      display: false,
                      text: "Chart.js Line Chart - Multi Axis",
                    },
                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    y: {
                      type: "linear",
                      display: true,
                      position: "left",
                      title: { display: false, text: "°C" },
                      min: 0,
                    },
                  },
                },
              };
              this.luxChart.loaded = true;
            }
          }
        })
        .catch((err) => {
  // 🚨 FAILURE PATH 🚨
  console.error("--- API REQUEST FAILED ---");
  console.error("Error details:", err); // <--- We need this output
  console.log("----------------------------");
  
  this.isChartLoading = false;
});
      this.luxChart.loaded = true;
    },
    handleMapShown() {
      // Ensure the map object is available
      if (!this.$refs.luxMap) return;
      const map = this.$refs.luxMap.leafletObject;
      if (map) {
        map.invalidateSize(); // Recalculate the map size
        this.fitMapToMarkers(); // Refit map bounds to markers
      } else {
        console.error("Map object is not ready yet");
      }
    },
  },
  watch: {},
  mounted() {
    setTimeout(() => {
      this.handleMapShown();
    }, 1500);
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },
  unmounted() {
    let popovers = document.getElementsByClassName("tooltip");
    popovers.forEach((item) => {
      item.remove();
    });
  },
  computed: {},
};
</script>

<style>
.datepicker-here {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 51px;
  color: #9b9a9a;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: none;
  padding: 16px 2px;
  width: 310px;
  text-align: left;
  border-radius: 8px;
  background: #fff;

  &:active {
    border: none;
  }

  &::after {
    color: #0492ff;
  }
}
</style>
